import React from "react";

const icons = {
  "slash-circle": (
    <path
      d="M12 2a10 10 0 1 0 7.07 2.93A9.96 9.96 0 0 0 12 2Zm0 2a8 8 0 0 1 5.66 2.34L6.34 17.66A8 8 0 0 1 12 4Zm0 16a8 8 0 0 1-5.66-2.34L17.66 6.34A8 8 0 0 1 12 20Z"
      fill="currentColor"
    />
  ),
  "check-circle": (
    <path
      d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm-1 13.2-3.2-3.2 1.4-1.4L11 12.4l4.8-4.8 1.4 1.4Z"
      fill="currentColor"
    />
  ),
  "shield-check": (
    <path
      d="M12 2 4 5v6c0 5 3.4 9.4 8 11 4.6-1.6 8-6 8-11V5Zm-1 13.2-3.2-3.2 1.4-1.4L11 12.4l4.8-4.8 1.4 1.4Z"
      fill="currentColor"
    />
  ),
  star: (
    <path
      d="M12 2 9.2 8.2 2 9l5.3 4.7L5.8 21 12 17.6 18.2 21l-1.5-7.3L22 9l-7.2-.8Z"
      fill="currentColor"
    />
  ),
  sparkles: (
    <path
      d="M12 2 13.3 6.7 18 8l-4.7 1.3L12 14l-1.3-4.7L6 8l4.7-1.3ZM5 16l.7 2.7L8 19l-2.3.3L5 22l-.7-2.7L2 19l2.3-.3ZM19 15l.7 2.7 2.3.3-2.3.3L19 21l-.7-2.7-2.3-.3 2.3-.3Z"
      fill="currentColor"
    />
  ),
  leaf: (
    <path
      d="M20 4c-7 0-12 4.5-12 11v5h2v-5c0-5.5 3.7-8.6 10-9.9Z"
      fill="currentColor"
    />
  ),
  users: (
    <path
      d="M8 12a4 4 0 1 1 4-4 4 4 0 0 1-4 4Zm8 0a3 3 0 1 1 3-3 3 3 0 0 1-3 3ZM2 20a6 6 0 0 1 12 0Zm13 0a5 5 0 0 1 7 0Z"
      fill="currentColor"
    />
  ),
  building: (
    <path
      d="M4 22V4l8-2 8 2v18Zm3-2h2v-3H7Zm0-5h2v-3H7Zm0-5h2V7H7Zm6 10h2v-3h-2Zm0-5h2v-3h-2Zm0-5h2V7h-2Z"
      fill="currentColor"
    />
  ),
  "file-text": (
    <path
      d="M6 2h8l4 4v16H6Zm2 8h8v2H8Zm0 4h8v2H8Zm0-8h4v2H8Z"
      fill="currentColor"
    />
  ),
  "clipboard-check": (
    <path
      d="M9 2h6l1 2h3v18H5V4h3Zm2 11-2.5-2.5 1.4-1.4L11 10.2l3.6-3.6 1.4 1.4Z"
      fill="currentColor"
    />
  ),
  award: (
    <path
      d="M12 2a6 6 0 1 1-6 6 6 6 0 0 1 6-6Zm0 14 4 6-4-2-4 2Z"
      fill="currentColor"
    />
  ),
  search: (
    <path
      d="M10 2a8 8 0 1 1-5.66 13.66L2 18l1.4 1.4 2.34-2.34A8 8 0 0 1 10 2Z"
      fill="currentColor"
    />
  ),
  "file-pdf": (
    <path
      d="M6 2h8l4 4v16H6Zm3 8h1.8c1.3 0 2.2.7 2.2 2s-.9 2-2.2 2H9Zm1.6 3c.6 0 1-.3 1-.9s-.4-.9-1-.9H10v1.8Zm5.4 1h2v2h-4V10h4v2h-2Zm0-8h-2V4h-2v2H9V4H7v4h10Z"
      fill="currentColor"
    />
  ),
  code: (
    <path
      d="M8 16 3 12l5-4 1.4 1.4L5.8 12l3.6 2.6Zm8 0-1.4-1.4 3.6-2.6-3.6-2.6L16 8l5 4Zm-5.2 4-1.6-.4 3-12 1.6.4Z"
      fill="currentColor"
    />
  ),
  "external-link": (
    <path
      d="M14 3h7v7h-2V6.4l-8.3 8.3-1.4-1.4L17.6 5H14ZM5 5h6V3H3v8h2Z"
      fill="currentColor"
    />
  ),
  copy: (
    <path
      d="M8 8h10v12H8Zm-4-4h10v2H6v8H4Z"
      fill="currentColor"
    />
  ),
};

const Icon = ({ name, size = 24, color = "currentColor", className = "", title }) => {
  const iconPath = icons[name];
  if (!iconPath) return null;

  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      aria-hidden={title ? undefined : true}
      role={title ? "img" : "presentation"}
      className={className}
      style={{ color }}
    >
      {title ? <title>{title}</title> : null}
      {iconPath}
    </svg>
  );
};

export default Icon;
